import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

export const RegionContainer = styled.div`
  display: flex;
  gap: ${Variables.space150};
  flex-direction: column;

  @media (min-width: ${Variables.breakpointM}) {
    gap: ${Variables.space250};
  }
`;
